import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { Button, Tooltip } from "antd";

import { DownloadOutlined } from "@ant-design/icons";

import TrlFormat from "./documents/TrlFormat";
import TriFormat from "./documents/TriFormat";
import CosFormat from "./documents/CosFormat";
import CwaFormat from "./documents/CwaFormat";
import TripTicketFormat from "./documents/TripTicketFormat";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    fontFamily: "Arial",
    margin: "60px 0px",
  },
  section: {
    padding: "0px 20px",
    width: "50%",
  },
  fullPage: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    fontFamily: "Arial",
  },
  fullSection: {
    width: "100%",
  },
});

const FULL_PAGE_TYPES = ["cwa", "tripticket"];

const PdfContents = ({ contents, docuType, isEmployee }) => {
  const pdfComponents = {
    trl: <TrlFormat contents={contents} isEmployee={isEmployee} />,
    tri: <TriFormat contents={contents} isEmployee={isEmployee} />,
    cos: <CosFormat contents={contents} isEmployee={isEmployee} />,
    cwa: <CwaFormat contents={contents} isEmployee={isEmployee} />,
    tripticket: <TripTicketFormat contents={contents} />,
  };

  const SelectedPdfComponent = pdfComponents[docuType] || (
    <Text>Invalid Document Type</Text>
  );

  const isFullPage = FULL_PAGE_TYPES.includes(docuType);

  if (isFullPage) {
    return (
      <Document>
        <Page size="A4" style={styles.fullPage}>
          <View style={styles.fullSection}>{SelectedPdfComponent}</View>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>{SelectedPdfComponent}</View>
        <View style={styles.section}>{SelectedPdfComponent}</View>
      </Page>
    </Document>
  );
};

export default function GeneratePdf({
  disabled,
  contents = {},
  style = {},
  buttonText = "Generate PDF",
  docuType,
  isIcon = false,
  isEmployee = false,
}) {
  const openPdfInNewTab = async (e) => {
    e.stopPropagation();
    const blob = await pdf(
      <PdfContents
        contents={contents}
        docuType={docuType}
        isEmployee={isEmployee}
      />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const defaultStyle = disabled
    ? {}
    : {
        color: "white",
        backgroundColor: "#008767",
        borderColor: "#008767",
      };

  const mergedStyle = { ...defaultStyle, ...style };
  return (
    <Tooltip title={buttonText}>
      <Button
        onClick={openPdfInNewTab}
        disabled={disabled}
        type="primary"
        shape={isIcon ? "circle" : null}
        style={mergedStyle}
        icon={<DownloadOutlined />}
      >
        {isIcon ? null : buttonText}
      </Button>
    </Tooltip>
  );
}
